import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SurveyInputSelect = _resolveComponent("SurveyInputSelect")!
  const _component_BaseStyle = _resolveComponent("BaseStyle")!

  return (_openBlock(), _createBlock(_component_BaseStyle, {
    "content-style": new _ctx.Style({})
  }, {
    default: _withCtx(() => [
      _createVNode(_component_SurveyInputSelect, {
        modelValue: _ctx.purchaseCount,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.purchaseCount) = $event)),
        options: _ctx.options,
        placeholder: "購入本数を選択してください"
      }, null, 8, ["modelValue", "options"])
    ]),
    _: 1
  }, 8, ["content-style"]))
}